export const DEFAULT_PAGE_SIZE = 20;
export const EMPTY_VALUE = "-";
export const SYSTEM_USER_LABEL = "System";

export const COMPACT_HEADER_CLASS = "px-3 py-2 !whitespace-normal leading-tight";
export const ACTION_BUTTON_CLASS = "w-[4.75rem]";
